export const IMG_BASE_URL = "https://res.cloudinary.com/cotribute/image/upload";
export const AUTH_TOKEN_KEY = "jwt-auth";
export const REFRESH_TOKEN_KEY = "jwt-refresh";